
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-kits-5kva-48v-power-system",
      function () {
        return require("private-next-pages/power-kits-5kva-48v-power-system/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-kits-5kva-48v-power-system"])
      });
    }
  